<template>
  <div>
    <div class="intro-banner text-white text-xl">
      <p v-if="aiType === 'letter'">信件資訊</p>
      <p v-if="aiType === 'speech'">「日文演講稿資訊」</p>
    </div>

    <div class="intro-text bg-white p-4 text-lg">
      <form class="font-semibold" v-if="aiType === 'letter'">
        <div class="form-group">
          <label for="disabledTextInput">寄件人姓名</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="s_name">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">寄件人稱謂</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="s_itentity">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">寄件人公司</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="s_company">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">收件人姓名</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="r_name">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">收件人稱謂</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="r_itentity">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">收件人公司</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="r_company">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">信件主旨</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="purpose">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">信件內容描述</label>
          <textarea v-model="content" class="form-control" id="emailTitle" rows="3" placeholder="EX: 要誠摯邀請對方參與即將舉行的商業會議，共同探討機會，共創未來，會議時間在下個月13號。" disabled></textarea>
        </div>
        <a class="btn-submit mx-2 d-inline-block pointer" @click="editData">修改信件資訊</a>
      </form>
      <form class="font-semibold" v-if="aiType === 'speech'">
        <!-- <div class="form-group">
          <label for="disabledTextInput">演講類型</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="type">
        </div> -->
        <div class="form-group">
          <label for="disabledTextInput">演講主題</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="topic">
        </div>
        <!-- <div class="form-group">
          <label for="disabledTextInput">演講時長</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="duration">
        </div> -->
        <!-- <div class="form-group">
          <label for="disabledTextInput">演講場合</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="occasion">
        </div> -->
        <div class="form-group">
          <label for="disabledTextInput">演講對象</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="audience">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">演講細節</label>
          <textarea v-model="content" class="form-control" id="emailTitle" rows="3" placeholder="EX: 要誠摯邀請對方參與即將舉行的商業會議，共同探討機會，共創未來，會議時間在下個月13號。" disabled></textarea>
        </div>
        <a class="btn-submit mx-2 d-inline-block pointer" @click="editData">
          <span v-if="aiType === 'letter'">修改信件資訊</span>
          <span v-if="aiType === 'speech'">修改日文演講稿資訊</span></a>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inputData',
  props: {
    aiType: {
      type: String,
      default: null
    },
    r_name: {
      type: String,
      default: null
    },
    r_itentity: {
      type: String,
      default: null
    },
    r_company: {
      type: String,
      default: null
    },
    s_name: {
      type: String,
      default: null
    },
    s_itentity: {
      type: String,
      default: null
    },
    s_company: {
      type: String,
      default: null
    },
    purpose: {
      type: String,
      default: null
    },

    type: {
      type: String,
      default: null
    },
    topic: {
      type: String,
      default: null
    },
    // duration: {
    //   type: String,
    //   default: null
    // },
    // occasion: {
    //   type: String,
    //   default: null
    // },
    audience: {
      type: String,
      default: null
    },

    content: {
      type: String,
      default: null
    }
  },
  mounted () {
  },
  methods: {
    editData () {
      this.$emit('editData')
    }
  }
}
</script>
<style lang="scss" scoped>
  .intro-banner {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background: #0E103E;
    text-align: center;
    font-weight: 700;
    background-image:
      url('~@/assets/image/ai/plusSS.png'), url('~@/assets/image/ai/plusSS.png'),
      url('~@/assets/image/ai/plusS.png'), url('~@/assets/image/ai/plusS.png'),
      url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusB.png'),
      url('~@/assets/image/ai/robotL.png'), url('~@/assets/image/ai/robotR.png');
    background-repeat: no-repeat;
    background-position:
      left 18% top 15%, right 18% top 15%,
      left 6% top 30%, right 6% top 30%,
      left 13% top 55%, right 13% top 55%,
      left 10% bottom 0%, right 5% bottom 0%;
    p {
      margin: 0;
    }
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
  .intro-text{
    h6 {
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    p {
      margin-bottom: 1.25rem;
      line-height: 150%;
      font-weight: 500;
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    .title {
      font-weight: 700;
    }
    .icon-img {
      max-width: 1.5em;
      height: auto;
      object-fit: contain;
    }
  }
</style>
